import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Box } from '../common';
import ScheduleButton from './ScheduleButton';

const Row = styled(Box)`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid rgb(216, 216, 216);

  &:last-child {
    border-bottom: 0;
  }
`;

function ScheduleRow(props) {
  const {
    id,
    specialItems,
    reservedCols,
    renderSpecialItem,
    disabledExtractor,
    filledExtractor,
    errorExtractor
  } = props;
  const days = Array(6).fill(0);

  return (
    <Row>
      {days.map((item, index) => {
        const key = `schedule_btn_${index}`;
        const specialItem = specialItems ? specialItems[`col_${index}`] : null;
        const isReserved = reservedCols.includes(index);

        return (
          <ScheduleButton
            row={id}
            key={key}
            id={index}
            reserved={isReserved}
            selected={!!specialItem}
            specialItem={specialItem}
            renderSpecialItem={renderSpecialItem}
            disabledExtractor={disabledExtractor}
            filledExtractor={filledExtractor}
            errorExtractor={errorExtractor}
          />
        );
      })}
    </Row>
  );
}

ScheduleRow.propTypes = {
  id: PropTypes.number,
  specialItems: PropTypes.object,
  renderSpecialItem: PropTypes.func,
  disabledExtractor: PropTypes.func,
  filledExtractor: PropTypes.func,
  errorExtractor: PropTypes.func,
  reservedCols: PropTypes.array
};

ScheduleRow.defaultProps = {
  reservedCols: []
};

export default ScheduleRow;
